import { Skeleton } from "@mui/material";
import { ReactNode } from "react";


export default function PageHeader({ children, label, isLoading }: {
    children?: ReactNode,
    label: string,
    isLoading?: boolean,
}) {

    return (
        <div className="w-full flex justify-between items-start mb-4 gap-10">
            <div className='flex flex-col justify-start items-start gap-1 grow'>
                {isLoading !== undefined && isLoading ? (
                    <Skeleton variant='text' width='100%' sx={{ fontSize: '2.5rem' }}/>
                ) : (
                    <p className="font-semibold text-[2.5rem] text-default">{label}</p>
                )}
            </div>
            <div className='flex gap-3'>
                {children}
            </div>
        </div>
    )
}